"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Zap, Shield, Cpu, Lightbulb } from "lucide-react";
export default function SupportTraining() {
  const features = [{
    id: 1,
    icon: Zap,
    title: "Marketing Support",
    description: "Dominate your local market with professional branding, lead generation tools, and high-impact digital assets.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/marketing_support_bg.png"
  }, {
    id: 2,
    icon: Shield,
    title: "Sales Training",
    description: "Master the art of high-ticket outdoor living sales with our proven scripts, pricing models, and closing techniques.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/sales_training_bg.png"
  }, {
    id: 3,
    icon: Cpu,
    title: "Design Resources",
    description: "Access 3D rendering software and architectural templates to help clients visualize their dream outdoor space.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/design_resources_bg.png"
  }, {
    id: 4,
    icon: Lightbulb,
    title: "Field Training",
    description: "Hands-on technical instruction from master installers to ensure your crew builds faster with zero defects.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/field_training_bg.png"
  }];
  return <section data-section-id="231180" id="support-training" className="w-full bg-background py-24 text-foreground">
      <div className="mx-auto max-w-7xl px-8">
        {}
        <div className="mb-16 text-center">
          <h2 className="font-default text-5xl font-bold tracking-tight text-foreground">
            The ClifRock Support Ecosystem
          </h2>
        </div>

        {}
        <div className="grid gap-8 sm:grid-cols-1 md:grid-cols-2">
          {features.map((feature, i) => {
          const IconComponent = feature.icon;
          return <div key={feature.id} data-index={i} className="relative overflow-hidden rounded-lg">
                {}
                <div className="absolute inset-0 z-0 bg-cover bg-center" style={{
              backgroundImage: `url(${feature.image})`
            }} />
                
                <Card className="relative z-10 h-full border-none bg-white/40 shadow-lg backdrop-blur-xl transition-all duration-300 hover:bg-white/50">
                  <CardHeader className="px-8 pb-0 pt-8">
                    <div className="mb-4 flex items-center justify-start">
                      <div className="rounded-lg bg-primary/10 p-3">
                        <IconComponent className="h-10 w-10 text-primary" />
                      </div>
                    </div>
                    <CardTitle className="font-default text-2xl font-bold text-foreground">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="px-8 pt-4 pb-8">
                    <p className="font-default text-base font-medium text-foreground/90">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}